import { Button, Sheet, Stack, Typography } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import FullPageContainer from "pages/container/FullPageContainer";
import { PATH } from "routes/paths";
import { theme } from "styles/theme";

export default function TaskEditorAccessDenied() {
  const navigate = useNavigate();

  return (
    <FullPageContainer
      backgroundColor={theme.vars.palette.Background.Level1}
      hasFooter={false}
      disableBottomSafeArea
    >
      <Stack
        sx={{
          width: "100%",
          flex: 1,
          px: "20px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            width: "100%",
            maxWidth: "420px",
            px: "20px",
            pt: "32px",
            pb: "32px",
            borderRadius: "24px",
            border: 0,
            boxShadow: theme.shadow.lg,
            backgroundColor: theme.vars.palette.Surface.Forward,
          }}
        >
          <Stack spacing={1.5}>
            <Typography
              variant={"Subtitle"}
              sx={{ color: theme.vars.palette.Content.Strong, fontWeight: 700 }}
            >
              접근 권한이 없는 페이지입니다.
            </Typography>
            <Typography
              variant={"Body"}
              sx={{
                color: theme.vars.palette.Content.Weak,
                lineHeight: 1.5,
                whiteSpace: "pre-line",
              }}
            >
              현재 계정은 활동지 에디터를 사용할 수 없습니다.
              {"\n"}
              권한이 필요하면 운영 담당자에게 문의해주세요.
            </Typography>
            <Button
              onClick={() => navigate(PATH.home, { replace: true })}
              sx={{ alignSelf: "flex-end", fontWeight: 700 }}
            >
              홈으로 이동
            </Button>
          </Stack>
        </Sheet>
      </Stack>
    </FullPageContainer>
  );
}
